"use client";
import Script from "next/script";

const TawkChat = () => {
  return (
    <Script id="tawk-widget" strategy="lazyOnload">
      {`
        var Tawk_API = window.Tawk_API = window.Tawk_API || {}, Tawk_LoadStart = new Date();

        Tawk_API.onLoad = function () {
          // A "talk to us" button was clicked before the widget finished loading.
          if (window.__tawkOpenOnLoad) {
            window.__tawkOpenOnLoad = false;
            Tawk_API.maximize();
          }
        };
        // Re-open the chat window whenever an agent sends a message.
        Tawk_API.onChatMessageAgent = function () {
          Tawk_API.maximize();
        };

        (function(){
          var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
          s1.async=true;
          s1.src='https://embed.tawk.to/6abc4570100fc5344640ab9a/1k3nmugj0';
          s1.charset='UTF-8';
          s1.setAttribute('crossorigin','*');
          s0.parentNode.insertBefore(s1,s0);
        })();
      `}
    </Script>
  );
};

export default TawkChat;
